export default __webpack_public_path__ + "static/media/man.b3ff1ca4.png";